export default [
  {
    path: '/member/login',
    name: 'login',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/member/Login')
  },
  {
    path: '/member/find_info_admin',
    name: 'findInfoAdmin',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/member/find_info_admin')
  },
  {
    path: '/member/admin_agreement',
    name: 'adminAgreement',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/member/adminAgreement')
  },
  {
    path: '/member/reset_password',
    name: 'resetPassword',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/member/ResetPassword')
  },
  {
    path: '/member/change_password',
    name: 'ChangePassword',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/member/ChangePassword')
  },
  {
    path: '/member/otp/email', // 이메일 인증
    name: 'OtpEmail',
    meta: {
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "OtpEmail" */ '@/views/member/OtpEmail')
  },
  {
    path: '/member/otp/authy', // otp 인증
    name: 'OtpAuthy',
    meta: {
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "OtpAuthy" */ '@/views/member/OtpAuthy')
  }
];



// WEBPACK FOOTER //
// ./src/router/subRoutes/member.js